export enum OperatingSystemEnum { ANDROID, IOS, OTHER }

export default class OperatingSystemUtility {

    public static isAndroid(): boolean {
        return /Android/i.test(navigator.userAgent);
    }

    public static isIOS(): boolean {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    public static getOperatingSystem(): OperatingSystemEnum {
        if (this.isAndroid()) return OperatingSystemEnum.ANDROID;
        else if (this.isIOS()) return OperatingSystemEnum.IOS;
        return OperatingSystemEnum.OTHER;
    }

}